<template>
  <div class="body-box marginBox2">
    <el-row class="plan"></el-row>

    <el-form
      ref="editFormRef"
      :model="editForm"
      label-width="140px"
      style="padding: 20px;background-color: #fff;margin-top: 10px;"
    >
      <el-row>
        <!--球场名称-->
        <el-col :span="8">
          <el-form-item label="比赛名称(用户)">
            <span class="colorStatus">{{newContent.name}}</span>
          </el-form-item>


          <el-form-item label="比赛名称">
            <el-input v-model="editForm.name"/>
          </el-form-item>
        </el-col>

        <!--希望球场-->
        <el-col :span="8">
          <el-form-item label="希望球场(用户)">
            <span class="colorStatus">{{newContent.courtName}}</span>
          </el-form-item>

          <el-form-item label="希望球场">
            <el-input v-model="editForm.courtName"/>
          </el-form-item>
        </el-col>

        <!--开始日-->
        <el-col :span="8">
          <el-form-item label="开始日(用户)">
            <span class="colorStatus">{{newContent.raceDate | formatDate}}</span>
          </el-form-item>

          <el-form-item label="开始日">
            <el-date-picker style="width: 100%;" v-model="editForm.raceDate" type="date" value-format="timestamp"></el-date-picker>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span="8">
          <el-form-item label="打球时间起(用户)">
            <span class="colorStatus">{{newContent.raceTime | formatDate('hh:mm:ss')}}</span>
          </el-form-item>

          <el-form-item label="打球时间起">
            <el-time-picker value-format="timestamp" v-model="editForm.raceTime" style="width: 100%;"></el-time-picker>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span="8">
          <el-form-item label="打球时间至(用户)">
            <span class="colorStatus">{{newContent.raceEndTime | formatDate('hh:mm:ss')}}</span>
          </el-form-item>

          <el-form-item label="打球时间至">
            <el-time-picker value-format="timestamp" v-model="editForm.raceEndTime" style="width: 100%;"></el-time-picker>
          </el-form-item>
        </el-col>

        <!--预约人-->
        <el-col :span="8">
          <el-form-item label="预约人(用户)">
            <span class="colorStatus">{{newContent.userName}}</span>
          </el-form-item>

          <el-form-item label="预约人">
            <el-input v-model="editForm.userName"/>
          </el-form-item>
        </el-col>

        <!--预约人电话-->
        <el-col :span="8">
          <el-form-item label="预约人电话(用户)">
            <span class="colorStatus">{{newContent.tel}}</span>
          </el-form-item>

          <el-form-item label="预约人电话">
            <el-input v-model="editForm.tel"/>
          </el-form-item>
        </el-col>

        <!--预约人邮箱-->
        <el-col :span="8">
          <el-form-item label="预约人邮箱(用户)">
            <span class="colorStatus">{{newContent.email}}</span>
          </el-form-item>

          <el-form-item label="预约人邮箱">
            <el-input v-model="editForm.email"/>
          </el-form-item>
        </el-col>

        <!--组数-->
        <el-col :span="8">
          <el-form-item label="组数(用户)">
            <span class="colorStatus">{{newContent.num}}</span>
          </el-form-item>

          <el-form-item label="组数">
            <el-input v-model="editForm.num"/>
          </el-form-item>
        </el-col>

        <!--方式-->
        <el-col :span="8">
          <el-form-item label="方式(用户)">
            <span class="colorStatus">{{newContent.kickOffMode === 'OSC' ? '連続' : newContent.kickOffMode === 'OI' ? 'OUT、IN同時' : 'ショットガン'}}</span>
          </el-form-item>

          <el-form-item label="方式">
            <el-select v-model="editForm.kickOffMode" clearable placeholder="请选择方式" style="width: 100%">
              <el-option v-for="item in raceWay" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--计算方式-->
        <el-col :span="8">
          <el-form-item label="计算方式(用户)">
            <span class="colorStatus">{{newContent.record === 'UL36' ? 'ダブルペリア(上限36）' : newContent.record === 'NUL' ? 'ハンディ制' : 'ダブルペリア（上限なし）'}}</span>
          </el-form-item>

          <el-form-item label="计算方式">
            <el-select v-model="editForm.record" clearable placeholder="请选择方式" style="width: 100%">
              <el-option v-for="item in calculation" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--成绩表-->
        <el-col :span="8">
          <el-form-item label="成绩表(用户)">
            <span class="colorStatus">{{newContent.gradeTable === 'MAX' ? '大きいサイズ' : 'A4サイズ'}}</span>
          </el-form-item>

          <el-form-item label="成绩表">
            <el-select v-model="editForm.gradeTable" clearable placeholder="请选择成绩表" style="width: 100%">
              <el-option v-for="item in gradeTable" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--食物-->
        <el-col :span="8">
          <el-form-item label="食物(用户)">
            <span class="colorStatus">{{newContent.food === 'YES' ? 'コンペ料理希望' : '手配不要'}}</span>
          </el-form-item>

          <el-form-item label="食物">
            <el-select v-model="editForm.food" clearable placeholder="请选择食物" style="width: 100%">
              <el-option v-for="item in raceFood" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--班车-->
        <el-col :span="8">
          <el-form-item label="班车(用户)">
            <span class="colorStatus">{{newContent.bus === 'YES' ? '要' : '不要'}}</span>
          </el-form-item>

          <el-form-item label="班车">
            <el-select v-model="editForm.bus" clearable placeholder="请选择食物" style="width: 100%">
              <el-option v-for="item in shuttleBus" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--其他-->
        <el-col :span="8">
          <el-form-item label="其他(用户)">
            <span class="colorStatus">{{newContent.other}}</span>
          </el-form-item>

          <el-form-item label="其他">
            <el-input v-model="editForm.other"/>
          </el-form-item>
        </el-col>

        <!--旗-->
        <el-col :span="8">
          <el-form-item label="远近洞(用户)">
            <span class="colorStatus">{{newContent.prize === 'YES' ? '要' : '不要'}}</span>
          </el-form-item>

          <el-form-item label="远近洞">
            <el-select v-model="editForm.prize" clearable placeholder="请选择远近洞" style="width: 100%" @change="distance">
              <el-option key="YES" label="要" value="YES"></el-option>
              <el-option key="NO" label="不要" value="NO"></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <!--近洞奖-->
        <el-col :span="8">
          <el-form-item label="近洞奖(用户)">
            <span class="colorStatus">{{newContent.nearHoleAward}}</span>
          </el-form-item>

          <el-form-item label="近洞奖">
            <el-input :disabled="editForm.prize === 'YES'" v-model="editForm.nearHoleAward"/>
          </el-form-item>
        </el-col>

        <!--远距奖-->
        <el-col :span="8">
          <el-form-item label="近洞奖(用户)">
            <span class="colorStatus">{{newContent.distanceAward}}</span>
          </el-form-item>

          <el-form-item label="近洞奖">
            <el-input :disabled="editForm.prize === 'YES'" v-model="editForm.distanceAward"/>
          </el-form-item>
        </el-col>

        <!--备注-->
        <el-col :span="24">
          <el-form-item label="备注(用户)">
            <span class="colorStatus">{{newContent.brief}}</span>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.brief"/>
          </el-form-item>
        </el-col>

        <!--用户修改的-->
        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">用户上传的打球人</el-col>
        <el-col :span="24" v-for="item in newGroupPerson">
          <el-row>
            <el-col :span="6" v-for="u in item.data" :key="u.id">
              <el-form-item label="打球人">
                <span class="colorStatus">{{u.name}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <!--修改打球人-->
        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">
          <span>打球列表</span>
          <el-button @click="replace" style="margin-left: 20px;">替换用户填写的打球人</el-button>
        </el-col>
        <el-col :span="24" v-for="item in groupPerson" :key="item.type">
          <el-row>
            <el-col :span="6" v-for="u in item.data" :key="u.id">
              <el-form-item label="打球人">
                <span>{{u.name}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click="goBack">返回</el-button>
      <el-button @click="submitModifyOrder">修改订单</el-button>
    </div>
  </div>
</template>

<script>
import { cancelOrdersByOrderId, modifyOrderRacesById } from '@/api/order/order'
import { raceWay, calculation, gradeTable, raceFood, shuttleBus } from '@/js/enum'

export default {
  name: "modifyGameOrder",
  data () {
    return {
      editForm: {},
      groupPerson: [],
      orderId: '',
      newContent: {},
      newGroupPerson: [],
      raceWay: raceWay,
      calculation: calculation,
      gradeTable: gradeTable,
      raceFood: raceFood,
      shuttleBus: shuttleBus,
    }
  },

  mounted() {
    this.orderId = this.$route.query.orderId
    this.initialize()
  },

  methods: {
    //初始化
    initialize() {
      cancelOrdersByOrderId(this.orderId).then(res => {
        this.editForm = JSON.parse(res.data.rawData)
        this.groupPerson = JSON.parse(this.editForm.groupPerson)
        this.newContent = JSON.parse(res.data.content)
        this.newGroupPerson = JSON.parse(this.newContent.groupPerson)
      })
    },

    //返回
    goBack() {
      this.$router.go(-1)
      localStorage.removeItem(this.orderId)
    },

    distance() {
      if (this.editForm.prize === 'YES') {
        this.editForm.distanceAward = 0
        this.editForm.nearHoleAward = 0
      }
    },

    //替换打球人
    replace() {
      this.groupPerson = this.newGroupPerson
    },

    submitModifyOrder() {
      let personNum = 0;
      if (this.groupPerson.length > 0) {
        this.groupPerson.forEach((item) => {
          personNum += item.data.length;
        })
      }

      const data = {
        brief: this.editForm.brief,
        bus: this.editForm.bus,
        courtName: this.editForm.courtName,
        distanceAward: this.editForm.distanceAward,
        email: this.editForm.email,
        enumStatus: this.editForm.enumStatus,
        food: this.editForm.food,
        gradeTable: this.editForm.gradeTable,
        groupPerson: JSON.stringify(this.groupPerson),
        kickOffMode: this.editForm.kickOffMode,
        name: this.editForm.name,
        nearHoleAward: this.editForm.nearHoleAward,
        num: this.editForm.num,
        other: this.editForm.other,
        personNum: personNum,
        prize: this.editForm.prize,
        raceDate: this.editForm.raceDate,
        raceEndTime: this.editForm.raceEndTime,
        raceTime: this.editForm.raceTime,
        record: this.editForm.record,
        tel: this.editForm.tel,
        userName: this.editForm.userName
      }

      modifyOrderRacesById(data, this.orderId).then(res => {
        if (res.code === '0') {
          this.$message.success('执行成功!')
          localStorage.removeItem(this.orderId)
          this.goBack()
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.colorStatus {
  color: red;
}
</style>
